import { BinaryWriter } from "../binary.js";
import { ServerOp } from "../opcodes.js";
export function encodeRedirect(packet, writer = new BinaryWriter(96)) {
    writer.u8(ServerOp.Redirect).str8(packet.host).u16(packet.port).str8(packet.token);
    return writer;
}
export function decodeRedirect(reader) {
    return { host: reader.str8(), port: reader.u16(), token: reader.str8() };
}
//# sourceMappingURL=redirect.js.map